// General url paths
export const USER = "/user";
export const PETS = "/pets";

// CORRECT THIS
export const SIGN_UP = "/register";
export const FEEDBACK_SUBMIT = "/submit_feedback"
export const LOGIN = "/login";
export const CLINIC_LOGIN = LOGIN + "/:shortName";
export const TERMS = "/terms";
export const VERIFY = "/verify";
export const NEW_EMAIL_CONFIRMATION = "verify_email";
export const RESEND_VERIFICATION_EMAIL = "/resend_verification_mail";
export const EMPLOYEE_ACTIVATION = "/employee_verification";
export const USER_ACTIVATION = "/user_activation";
export const USER_ACTIVATION_CONFIRM = "/user_activation/confirm";
export const TERMS_INTERNAL = "/terms_and_conditions";
export const APPOINTEMENTS = "/appointements";
export const HOME = "/home";
export const INBOX = "/inbox";
export const DEFAULT = "/";
export const SETTINGS = USER + "/administration";
export const ADMINISTRATION = USER + "/administration";
export const SPECIES_ADMINISTRATION = "/admin/species";
export const CLINIC_LIST = "/admin/clinics";
export const PROFILE_EDIT = USER + "/edit_profile";
export const PROFILE_EDIT_SETTINGS = "/user/edit_profile?tab=Settings";
export const FORGOTTEN_PASSWORD = "/forgotten_password";
export const ACCOUNT_DELETE_REQUEST_PAGE = "/delete_account"
export const ACCOUNT_DELETE_CONFIRMATION_PAGE = "/delete_account/confirmation"
export const CHANGE_FORGOTTEN_PASSWORD = "/change_forgotten_password";
export const USER_CHANGE_PASSWORD = "/user_change_password";
export const CHANGE_USER_EMAIL = "/user_change_email";
export const NOTIFICATIONS = "/notifications";

// User appointement url paths
export const APPOINTEMENT_DETAILS = APPOINTEMENTS + "/details/";
export const APPOINTEMENT_DETAILS_ID = APPOINTEMENTS + "/details/:id";
export const CLINI_APPOINTMENT_DETAILS = "/user/admin/appointements/details/"

// User pets url paths
export const PET_DETAILS_ID = PETS + "/pet/:id";
// Old links carried the owner as a path segment; kept only to redirect to ?user=
export const LEGACY_PET_DETAILS_ID = PETS + "/pet/:id/:ownerId";
export const PET_DETAILS_ = PETS + "/pet/";
export const PET_VIEW_USER_PARAM = "user";
export const PET_VIEW_TAB_PARAM = "tab";

// Single pet view URL - the user id is omitted for clinic-owned pets
export function petViewUrl(petId, userId, tab) {
  const params = new URLSearchParams();
  if (userId !== null && userId !== undefined && userId !== "") {
    params.set(PET_VIEW_USER_PARAM, userId);
  }
  if (tab) params.set(PET_VIEW_TAB_PARAM, tab);
  const query = params.toString();
  return PET_DETAILS_ + petId + (query ? "?" + query : "");
}

//Admin url
export const ADMIN = USER + "/admin";

//Product price administration
export const PRICE_ADMINISTRATION = ADMIN + "/prices";
export const SINGLE_PRICE_ADMINISTRATION = PRICE_ADMINISTRATION + "/details/";
export const SINGLE_PRICE_ADMINISTRATION_ID =
  PRICE_ADMINISTRATION + "/details/:id";

// Reservation administration
export const RESERVATION_ADMINISTRATION = ADMIN + APPOINTEMENTS;
export const PENDING_APPOINTMENTS = ADMIN + APPOINTEMENTS + "/pending";
export const PENDING_APPOINTEMENT_DETAILS = ADMIN + APPOINTEMENTS + "/pending/";
export const PENDING_APPOINTEMENT_DETAILS_ID =
  ADMIN + APPOINTEMENTS + "/pending/:id";

//Templates
export const TEMPLATE = "/templates";
export const TEMPLATE_DETAILS_ = TEMPLATE + "/template/";
export const TEMPLATE_DETAILS_ID = TEMPLATE_DETAILS_ + ":id";

export const SINGLE_RESERVATION_ADMINISTRATION_DETAILS =
  RESERVATION_ADMINISTRATION + "/details/";

export const SINGLE_RESERVATION_ADMINISTRATION_DETAILS_ID =
  RESERVATION_ADMINISTRATION + "/details/:id";

export const ABOUT_US = "/about_us";
export const MASTER_SINGLE_CLINIC_ID =
  "/user/master/settings/clinic/:clinicName/:id";
export const SINGLE_CLINIC_ID = "/user/settings/clinic/:id";
export const SINGLE_CLINIC_EMPLOYEES_ID = "/user/settings/clinic/employees/:id";
export const SINGLE_CLINIC_SERVICES_ID = "/user/settings/clinic/services/:id/";
export const SINGLE_CLINIC_WORKINGHOURS_ID =
  "/user/settings/clinic/workinghours/:id";
export const SINGLE_CLINIC_CHANGELOGO_ID =
  "/user/settings/clinic/changelogo/:id";
export const SINGLE_CLINIC_SPECIES_ID = "/user/settings/clinic/species/:id";
export const SINGLE_CLINIC_BLOOD_DONORS_ID = "/user/settings/clinic/blood_donors/:id";
export const SINGLE_CLINIC_DOCUMENTCATEGORIES_ID =
  "/user/settings/clinic/document_categories/:id";
export const SINGLE_CLINIC_INFORMATIONFIELDS_ID =
  "/user/settings/clinic/information_fields/:id";
export const MASTER_SINGLE_CLINIC = "/user/master/settings/clinic/";
export const SINGLE_CLINIC = "/user/settings/clinic/";
export const SINGLE_CLINIC_OPTIONS = "/user/settings/clinic/options/";
export const SINGLE_CLINIC_EMPLOYEES = "/user/settings/clinic/employees/";
export const SINGLE_CLINIC_SERVICES = "/user/settings/clinic/services/";
export const SINGLE_CLINIC_WORKINGHOURS = "/user/settings/clinic/workinghours/";
export const SINGLE_CLINIC_CHANGELOGO = "/user/settings/clinic/changelogo/";
export const SINGLE_CLINIC_SPECIES = "/user/settings/clinic/species/";
export const SINGLE_CLINIC_BLOOD_DONORS  = "/user/settings/clinic/blood_donors/";
export const SINGLE_CLINIC_DOCUMENTCATEGORIES =
  "/user/settings/clinic/document_categories/";
export const SINGLE_CLINIC_INFORMATIONFIELDS =
  "/user/settings/clinic/information_fields/";
export const SINGLE_USER_PERMISSIONS_ID =
  "/user/settings/clinic/single_user/permissions/:id";
export const SINGLE_USER_PERMISSIONS =
  "/user/settings/clinic/single_user/permissions/";
export const SINGLE_CLINIC_OPTIONS_ID = "/user/settings/clinic/options/:id";
export const SINGLE_CLINIC_WAREHOUSE = "/user/settings/clinic/warehouse/";
export const SINGLE_CLINIC_WAREHOUSE_ID =
  "/user/settings/clinic/warehouse/:id";
export const SINGLE_WAREHOUSE_ITEM_ID =
  "/user/settings/clinic/warehouse/item/:itemId";
export const SINGLE_WAREHOUSE_ITEM =
  "/user/settings/clinic/warehouse/item/";

//Clinic users
export const CLINIC_USERS = "/clinic/allUsers";
export const MASTER_CLINIC_USERS = "/master/clinic/allUsers";
export const SINGLE_CLINIC_USER = "/clinic/user/";
export const SINGLE_CLINIC_USER_ID = "/clinic/user/:id";
export const IMPORT_USERS_PAGE = CLINIC_USERS + "/import"

//Employees
export const SINGLE_EMPLOYEE_ID = "/employees/edit/:id";
export const SINGLE_EMPLOYEE = "/employees/edit/";

//Master clinic user editing
export const MASTER_USER_EDITING = "/master/user/profile/edit/";
export const MASTER_USER_EDITING_ID = "/master/user/profile/edit/:id";
//QR code
export const QR_REDIRECT_ID = "/qr/redirect/:id";
export const QR_REDIRECT = "/qr/redirect";

//Saps
export const SAPS_HOME_PAGE = "/saps"
export const SAPS_ARCHIVE = "/saps/archive"
export const SINGLE_BOX_VIEW_NO_ID = "/saps/boxes/box/"
export const SINGLE_BOX_VIEW = "/saps/boxes/box/:id"
export const SINGLE_ARCHIVE_VIEW = '/saps/stay/archive/:id'
export const SINGLE_ARCHIVE_VIEW_NO_ID = '/saps/stay/archive/'
export const SINGLE_PET_VIEW = "/saps/pets/pet/:id"
export const SINGLE_PET_VIEW_NO_ID = "/saps/pets/pet/"
export const SAPS_PETS_VIEW = "/saps/pets"

export const SINGLE_THERAPY_VIEW_ID = "/saps/boxes/box/therapy/:id"
export const SINGLE_THERAPY_VIEW = "/saps/boxes/box/therapy/"
export const UPDATE_THERAPY_DAY = "/therapy/update/single/day/"

export const AI_ASSISTANT = "/saps/ai_assistant"
